import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const ToasterInfoIcon = () => <InfoOutlinedIcon color="info" sx={{ fontSize: 'inherit' }} />;
